import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { api } from "../lib/api";

export default function HotThisWeek() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api.get("/products/hot-this-week?limit=3")
      .then((r) => { if (!cancelled) setItems(r.data || []); })
      .catch(() => { /* hide gracefully */ });
    return () => { cancelled = true; };
  }, []);

  if (items.length === 0) return null;
  const anySaves = items.some((p) => (p.wishlist_saves || 0) > 0);

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-testid="hot-this-week">
      <div className="flex items-baseline justify-between flex-wrap gap-2 mb-8">
        <div className="flex items-center gap-3">
          <Flame className="w-5 h-5 text-[var(--accent)]" />
          <h2 className="font-serif text-3xl sm:text-4xl tracking-tight">Hot this week</h2>
        </div>
        <Link to="/shop" className="text-xs uppercase tracking-[0.2em] text-[var(--accent)] hover:underline">
          Browse the shop →
        </Link>
      </div>
      {anySaves && (
        <p className="text-sm text-[#5C5547] mb-6 -mt-4">The pieces other shoppers can't stop saving.</p>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {items.map((p) => (
          <Link to={`/product/${p.id}`} key={p.id} data-testid={`hot-${p.id}`}
            className="group relative rounded-3xl overflow-hidden border border-[#EAE4D3] bg-[#FDFBF7] hover:border-[var(--accent)]/60 transition">
            <div className="aspect-[4/5] bg-[#F5F2EA] overflow-hidden">
              {p.image_url && <img src={p.image_url} alt={p.title} className="w-full h-full object-cover transition group-hover:scale-105" />}
            </div>
            {(p.wishlist_saves || 0) > 0 && (
              <div className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[var(--accent)] text-black text-[10px] font-semibold uppercase tracking-[0.15em]" data-testid={`hot-save-count-${p.id}`}>
                <Flame className="w-3 h-3" /> {p.wishlist_saves} saves
              </div>
            )}
            <div className="p-5">
              <div className="font-serif text-xl leading-tight line-clamp-2">{p.title}</div>
              {Number(p.price) > 0 && (
                <div className="mt-2 text-sm gold-text">${Number(p.price).toFixed(2)}</div>
              )}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
